import React, { useState } from "react";
import "../styles/QuestionPage.css";
import plusIcon from "../assets/plusicon.png";
import minusIcon from "../assets/minusicon.png";

const questionsData = [
  {
    question:
      "What is an AI art generator, and how does it differ from traditional digital art tools?",
    answer:
      "An AI art generator is a application that uses artificial intelligence algorithms to create images based on text descriptions or other images. Unlike traditional digital art tools, which require human artists to manipulate pixels or shapes, AI art generators automate the creative process, allowing users to generate a wide range of artistic styles and concepts.",
  },
  {
    question: "How long does it typically take to generate an image?",
    answer:
      "Image generation time varies depending on the complexity of the prompt, the size of the image, and the computational resources available. Typically, it can range from a few seconds to several minutes.",
  },
  {
    question: "Can AI art generators be used for commercial purposes?",
    answer:
      "The commercial use of AI-generated art is subject to copyright and licensing restrictions. It's essential to check the terms of service of the AI art generator you're using and to consider potential copyright issues related to the training data.",
  },
  {
    question: "How can I improve the quality of the generated images?",
    answer:
      "Experimenting with different prompts, adjusting parameters, and using higher-quality training data can significantly impact the quality of generated images. Additionally, some AI art generators offer features like image upscaling or style transfer to enhance results.",
  },
  {
    question:
      "What hardware and software requirements are typically needed to run an AI art generator?",
    answer:
      "AI art generators are generally cloud-based applications, meaning you can access them through a web browser. However, some advanced features or high-resolution image generation might require a powerful GPU.",
  },
  {
    question:
      "What hardware and software requirements are typically needed to run an AI art generator?",
    answer:
      "AI art generators are generally cloud-based applications, meaning you can access them through a web browser. However, some advanced features or high-resolution image generation might require a powerful GPU.",
  },
];

const QuestionPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="questions-page">
      <div className="faq-header">
        <div className="line" />
        <h1 className="review-title">FAQ's</h1>
        <div className="line" />
      </div>
      <h2 className="questions-heading">
        Questions? We Have <br></br>Answers.
      </h2>
      <div className="content">
        <div className="question-section">
          {questionsData.map((item, index) => (
            <div key={index} className="question-item">
              <div
                className="question-header"
                onClick={() => toggleAnswer(index)}
              >
                <p className="question-text">{item.question}</p>
                <img
                  src={activeIndex === index ? minusIcon : plusIcon}
                  alt={activeIndex === index ? "Minus Icon" : "Plus Icon"}
                  className="togglee-icon1"
                />
              </div>
              {activeIndex === index && <p className="answer">{item.answer}</p>}
              <div className="divider" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuestionPage;
